<template>
    <div :key="uuid" class="col-4 toc_panel ace_sec" aria-label="TOC section">
        <b-list-group
            <div class="list-group-item">
                <div class="toc_row table-content-header">
                    <span class="icon-ic_ToC"></span>
                    <span class="hd_txt ace_sec_hd toc_hd_txt">{{course.title}} - {{LABELS.TOC}}</span>
                    <!--
                    <span class="progress_block">
    	                <span class="state" :class="statusClass(course.uuid)">
    	                	<span class="progress_val ace_sec_txt" :id="'prog_' + course.uuid"></span>
    	                </span>
                    </span>
                    -->
                    <span class="ic24-progress ace_sec_txt" :class="progressClass(course.uuid)"></span>
                </div>
            </div>
			<div class="content-scroll-column">
				<b-list-group-item class="topic-list-item" v-for="topic in topics" :key="topic.uuid">

					<div class="toc_row row_1" :id="'nodeRow_' + topic.uuid">
						<button class="icon ic-expand_r" :id="'ic_' + topic.uuid" v-b-toggle="'tc_' + topic.uuid" v-on:click="switchClass(topic.uuid)"></button>
						<b-link :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: topic.objectType, entityUuid: topic.uuid } }">
							<span :id="'lnk_txt_' + topic.uuid" class="lnk_txt" :aria-label="topic.title" v-on:click="expandCollapseTreeNode(topic.uuid)">{{topic.title}}</span>
						</b-link>
            <!--
						<span class="progress_block">
							<span class="state" :class="statusClass(topic.uuid)">
								<span class="progress_val ace_sec_txt" :id="'prog_' + topic.uuid"></span>
							</span>
						</span>
            -->
						<span class="icon-progress ace_sec_txt" :class="progressClass(topic.uuid)"></span>
            <b-popover :target="'lnk_txt_' + topic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + topic.uuid">
              <div class="title_container">
                {{topic.title}}
              </div>
            </b-popover>
            <div :id="'nodeRow_TitleContainer' + topic.uuid" class="title_container_popup"></div>
					</div>

					<!--sub topic -->
					<b-collapse :id="'tc_' + topic.uuid">
						<b-list-group v-if="topic.subtopics">

							<b-list-group-item class="topic-list-item" v-for="subtopic in topic.subtopics" :key="subtopic.uuid">
                <div class="toc_row row_3 top-level-assets" :class="{active_row:selectedRow === 'r_'+subtopic.uuid}" :id="'tc_' + subtopic.uuid" v-if="subtopic.objectType === 'LearningContent'">
                  <b-link v-if="subtopic.type === 'ASSESSMENT' || subtopic.type === 'RICH_HTML'" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }" @click="setSelectedRow(subtopic.uuid)">
                    <span class="ic_container"><span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
                    <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text"></span>
                    <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video"></span>
                    <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
                    <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'ppt' || subtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subtopic.uuid)"></span>
                    </span><span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" @click="setSelectedRow(subtopic.uuid)" :aria-label="subtopic.title">{{subtopic.title}}</span>
                  </b-link>
                  <b-link v-if="subtopic.type !== 'ASSESSMENT' && subtopic.type !== 'RICH_HTML'" :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }" @click="setSelectedRow(subtopic.uuid)">
                    <span class="ic_container"><span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
                    <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text"></span>
                    <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video"></span>
                    <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
                    <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'ppt' || subtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subtopic.uuid)"></span>
                    <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subtopic.uuid)"></span>
                    </span><span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" @click="setSelectedRow(subtopic.uuid)" :aria-label="subtopic.title">{{subtopic.title}}</span>
                  </b-link>
                  <!--
                  <span class="progress_block">
                    <span class="state" :class="statusClass(subtopic.uuid)" v-if="subtopic.fileType === 'assessment' || subtopic.type === 'RICH_HTML' || subtopic.fileType === 'scorm'">
                      <span class="progress_val ace_sec_txt" :id="'prog_' + subtopic.uuid"></span>
                    </span>
                    <span class="state ace_sec_txt" :class="resourseStatusClass(subtopic.uuid)" v-if="subtopic.fileType !== 'assessment'">
                    </span>
                  </span>
                  -->
                  <span class="icon-progress ace_sec_txt" :class="progressClass(subtopic.uuid)"></span>
                  <b-popover :target="'lnk_txt_' + subtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subtopic.uuid">
                    <div class="title_container">
                      {{subtopic.title}}
                    </div>
                  </b-popover>
                  <div :id="'nodeRow_TitleContainer' + subtopic.uuid" class="title_container_popup"></div>

                </div>
                <div class="toc_row row_2" :id="'nodeRow_' + subtopic.uuid" v-else>
									<button class="icon ic-expand_r" :id="'ic_' + subtopic.uuid" v-b-toggle="'tc_' + subtopic.uuid" v-on:click="switchClass(subtopic.uuid)"></button>
									<b-link :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }">
										<span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" :aria-label="subtopic.title" v-on:click="expandCollapseTreeNode(subtopic.uuid)">{{subtopic.title}}</span>
									</b-link>
                  <!--
									<span class="progress_block">
										<span class="state" :class="statusClass(subtopic.uuid)">
											<span class="progress_val ace_sec_txt" :id="'prog_' + subtopic.uuid"></span>
										</span>
									</span>
                  -->
									<span class="icon-progress ace_sec_txt" :class="progressClass(subtopic.uuid)"></span>
                  <b-popover :target="'lnk_txt_' + subtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subtopic.uuid">
                    <div class="title_container">
                      {{subtopic.title}}
                    </div>
                  </b-popover>
                  <div :id="'nodeRow_TitleContainer' + subtopic.uuid" class="title_container_popup"></div>
                </div>

								<!-- sub sub topic -->
								<b-collapse :id="'tc_' + subtopic.uuid">
									<b-list-group v-if="subtopic.subtopics">
										<b-list-group-item class="topic-list-item" v-for="subsubtopic in subtopic.subtopics" :key="subsubtopic.uuid">
											<div class="toc_row row_3" :class="{active_row:selectedRow === 'r_'+subsubtopic.uuid}" :id="'tc_' + subsubtopic.uuid">
												<b-link v-if="subsubtopic.type === 'ASSESSMENT' || subsubtopic.type === 'RICH_HTML'" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid } }" @click="setSelectedRow(subsubtopic.uuid)">
													<span class="ic_container"><span v-if="subsubtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
													<span v-if="subsubtopic.fileType === 'txt'" class="icon icon-file-text"></span>
													<span v-if="subsubtopic.fileType === 'mp4' || subsubtopic.fileType === 'mp3'" class="icon icon-video"></span>
													<span v-if="subsubtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
													<span v-if="subsubtopic.fileType === 'doc' || subsubtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'ppt' || subsubtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
                          <span v-if="subsubtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
                          <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'jpg' || subsubtopic.fileType === 'jpeg' || subsubtopic.fileType === 'png' || subsubtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subsubtopic.uuid)"></span>
													</span><span :id="'lnk_txt_' + subsubtopic.uuid" class="lnk_txt" @click="setSelectedRow(subsubtopic.uuid)" :aria-label="subsubtopic.title">{{subsubtopic.title}}</span>
												</b-link>
                        <b-link v-if="subsubtopic.type !== 'ASSESSMENT' && subsubtopic.type !== 'RICH_HTML'" :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid } }" @click="setSelectedRow(subsubtopic.uuid)">
													<span class="ic_container"><span v-if="subsubtopic.fileType === 'assessment'" class="icon icon-assessment" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'video'" class="icon icon-video" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'pdf'" class="icon icon-file-pdf" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
													<span v-if="subsubtopic.fileType === 'txt'" class="icon icon-file-text"></span>
													<span v-if="subsubtopic.fileType === 'mp4' || subsubtopic.fileType === 'mp3'" class="icon icon-video"></span>
													<span v-if="subsubtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
													<span v-if="subsubtopic.fileType === 'doc' || subsubtopic.fileType === 'docx'" class="icon icon-file-word" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'ppt' || subsubtopic.fileType === 'pptx'" class="icon icon-pagePPT" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'xlsx'" class="icon icon-file-excel" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
                          <span v-if="subsubtopic.fileType === 'other'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
                          <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'externalurl'" class="icon icon-pageURL" @click="setSelectedRow(subsubtopic.uuid)"></span>
													<span v-if="subsubtopic.fileType === 'jpg' || subsubtopic.fileType === 'jpeg' || subsubtopic.fileType === 'png' || subsubtopic.fileType === 'gif'" class="icon icon-image" @click="setSelectedRow(subsubtopic.uuid)"></span>
													</span><span :id="'lnk_txt_' + subsubtopic.uuid" class="lnk_txt" @click="setSelectedRow(subsubtopic.uuid)" :aria-label="subsubtopic.title">{{subsubtopic.title}}</span>
												</b-link>
                        <!--
												<span class="progress_block">
													<span class="state" :class="statusClass(subsubtopic.uuid)" v-if="subsubtopic.fileType === 'assessment' || subsubtopic.fileType === 'scorm'">
														<span class="progress_val ace_sec_txt" :id="'prog_' + subsubtopic.uuid"></span>
													</span>
													<span class="state ace_sec_txt" :class="resourseStatusClass(subsubtopic.uuid)" v-if="subsubtopic.fileType !== 'assessment' && subsubtopic.fileType !== 'scorm'">
													</span>
												</span>
                        -->
												<span class="icon-progress ace_sec_txt" :class="progressClass(subsubtopic.uuid)"></span>
                        <b-popover :target="'lnk_txt_' + subsubtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subsubtopic.uuid">
                          <div class="title_container">
                            {{subsubtopic.title}}
                          </div>
                        </b-popover>
                        <div :id="'nodeRow_TitleContainer' + subsubtopic.uuid" class="title_container_popup"></div>
											</div>
										</b-list-group-item>
									</b-list-group>
								</b-collapse>
								<!-- sub sub topic ends-->

							</b-list-group-item>

						</b-list-group>
					</b-collapse>
					<!--sub topic ends -->

				</b-list-group-item>
			</div>
        </b-list-group>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'

export default {
  name: 'toc',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid'],
  components: {
  },
  data: () => {
    return {
      selectedRow: undefined,
      status_css: {
        10: 'noGrade',
        0: 'gradeE',
        1: 'gradeD',
        2: 'gradeC',
        3: 'gradeB',
        4: 'gradeA'
      },
      progress_state: {0: 'not_started', 1: 'in_progress', 2: 'completed', 3: 'failed'},
      progressClasses: {},
      resourse_status: {0: 'noGrade', 1: 'in_progress', 2: 'gradeA', 3: 'failed'},
      statusClasses: {}
    }
  },

  created () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.expandAfterRefresh()
      }, 1500)
    })
  },

  mounted () {
    this.loadCourseTopicsInfo()
  },

  updated () {
    this.$nextTick(() => {
      this.loadStatusClasses()
 /*
      setTimeout(() => {
        this.$forceUpdate()
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      }, 500)
 */
    })
  },

  methods: {
    ...mapActions([
      'loadCourseTopics',
      'loadCourseCompetencies'
    ]),

    expandAfterRefresh () {
      if (!this.subTopicUuid) {
        let entityUuid = this.$route.params.entityUuid
        let elemId = '#tc_' + entityUuid
        let childElem = $(elemId).closest('.list-group').parent().get(0)
        let childSibling = $(childElem).prev().get(0)
        if (childSibling) {
          let childNodeId = '#ic_' + $(childSibling).attr('id').split('_')[1]
          let parentElem = $(childSibling).closest('.list-group').parent().get(0)
          let parentSibling = $(parentElem).prev().get(0)
          if (parentSibling) {
            let parentNodeId = '#ic_' + $(parentSibling).attr('id').split('_')[1]
            if ($(parentNodeId).hasClass('collapsed')) {
              $(parentNodeId).click()
              $(childNodeId).click()
//              $(elemId).children('a').get(0).click()
            }
          }
        }
      }
    },

    loadCourseTopicsInfo () {
      if (this.uuid) {
        // this.loadCourseCompetencies(this.uuid)
        // this.$refs.loadingModal.show()
        this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true}).then(res => {
          setTimeout(() => {
            // if (this.$refs.loadingModal) {
              // this.$refs.loadingModal.hide()
            // }
            if (!$('#tc_' + this.entityUuid).hasClass('.row_3.active_row')) {
              $('#tc_' + this.entityUuid).addClass('active_row')
            }
          }, 500)
        })
      }
    },

    loadStatusClasses () {
      var status = 10
      var performance = 0
      if (this.courseCompetencies && this.courseCompetencies.length > 0) {
        for (var i = 0; i < this.courseCompetencies.length; i++) {
          var competency = this.courseCompetencies[i]
          if (competency) {
            status = competency.status
            this.progressClasses[competency.entityId] = this.progress_state[status]
            if ((competency.competencyType === 'RESOURCE') || ((competency.competencyType === 'SCORM') && !competency.performance)) {
              this.statusClasses[competency.entityId] = this.resourse_status[status]
            } else {
              performance = competency.performance
              if (performance !== null) {
                $('#prog_' + competency.entityId).html(performance.toFixed(2) + '%')
                if (performance >= 90) {
                  status = 4
                } else if (performance >= 80 && performance < 90) {
                  status = 3
                } else if (performance >= 65 && performance < 80) {
                  status = 2
                } else if (performance >= 40 && performance < 65) {
                  status = 1
                } else if (performance < 40) {
                  status = 0
                }
              } else {
                status = 10
              }
              this.statusClasses[competency.entityId] = this.status_css[status]
            }
          }
        }
      }
    },

    switchClass (rowId) {
      var elem = $('#ic_' + rowId)
      if (elem.hasClass('ic-expand_r')) {
        elem.removeClass('ic-expand_r')
        elem.addClass('ic-collapse_r')
      } else {
        elem.removeClass('ic-collapse_r')
        elem.addClass('ic-expand_r')
      }
    },

    statusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    resourseStatusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    progressClass (entityId) {
      if (entityId in this.progressClasses) {
        return this.progressClasses[entityId]
      } else {
        return 'not_started'
      }
    },

    expandCollapseTreeNode (entityId) {
      $('#ic_' + entityId).trigger('click')
    },

    setSelectedRow (uuid) {
      const rowId = 'r_' + uuid
      if ($('.row_3').hasClass('active_row')) {
        if (this.selectedRow !== rowId) {
          $('.row_3').removeClass('active_row')
        }
      }
      this.selectedRow = rowId
    }

  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'courseCompetencies': state => state.course.competencies
    })
  },

  watch: {
    entityUuid (newEntityUuid) {
      if (!$('#tc_' + this.entityUuid).hasClass('.row_3.active_row')) {
        $('#tc_' + this.entityUuid).addClass('active_row')
      }
    },
    courseCompetencies () {
      this.loadStatusClasses()
    },
    topics () {
      /*if (!this.entityUuid) {
        topicLoop: for (var i = 0; i < this.topics.length; i++) {
          const topic = this.topics[i]
          if (topic.subtopics && topic.subtopics.length > 0) {
            subTopicLoop: for (var j = 0; j < topic.subtopics.length; j++) {
              const subtopic = topic.subtopics[j]
              if (subtopic.objectType === 'LearningContent') {
                // this.$router.push({name: 'entityDetail', params: {uuid: this.course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid, topicUuid: topic.uuid, subTopicUuid: subtopic.uuid}})
                break topicLoop
              }
              if (subtopic.subtopics && subtopic.subtopics.length > 0) {
                subSubTopicLoop: for (var k = 0; k < subtopic.subtopics.length; k++) {
                  const subsubtopic = subtopic.subtopics[k]
                  if (subsubtopic && subsubtopic.uuid) {
                    // this.$router.push({name: 'entityDetail', params: {uuid: this.course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid, topicUuid: topic.uuid, subTopicUuid: subtopic.uuid}})
                    break topicLoop
                  }
                }
              } else { // subtopic.subtopics.length ===> 0

              }
            }
          } else { // topic.subtopics ===> 0

          }
        }
      } else { */
        if ($('.toc_row').hasClass('active_row')) {
          if (this.entityType === 'LearningContent') {
            $('.toc_row').removeClass('active_row')
          }
        }
        if (!$('#tc_' + this.entityUuid).hasClass('.row_3.active_row')) {
          // $('#tc_' + this.entityUuid).addClass('active_row')
          if (this.subTopicUuid) {
            if (!this.topicUuid) {
              topicLoop: for (var x = 0; x < this.topics.length; x++) {
                const topic = this.topics[x]
                subTopicLoop: for (var y = 0; y < topic.subtopics.length; y++) {
                  const subtopic = topic.subtopics[y]
                  if (subtopic && subtopic.uuid === this.subTopicUuid) {
                    this.topicUuid = topic.uuid
                    break topicLoop
                  }
                }
              }
            }
          } else {
            topicLoop: for (var a = 0; a < this.topics.length; a++) {
              const topic = this.topics[a]
              subTopicLoop: for (var b = 0; b < topic.subtopics.length; b++) {
                const subtopic = topic.subtopics[b]
                if (subtopic.uuid === this.entityUuid) {
                  this.topicUuid = topic.uuid
                  break topicLoop
                }
                if (subtopic.subtopics) {
                  subSubTopicLoop: for (var c = 0; c < subtopic.subtopics.length; c++) {
                    const subsubtopic = subtopic.subtopics[c]
                    if (subsubtopic && subsubtopic.uuid === this.entityUuid) {
                      this.topicUuid = topic.uuid
                      this.subTopicUuid = subtopic.uuid
                      break topicLoop
                    }
                  }
                }
              }
            }
          }
          if ($('#ic_' + this.topicUuid).hasClass('collapsed')) {
            $('#ic_' + this.topicUuid).trigger('click')
          }
          if ($('#ic_' + this.subTopicUuid).hasClass('collapsed')) {
            $('#ic_' + this.subTopicUuid).trigger('click')
          }
        }
      // }
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/theme/default/sass/mixin';
@import '../../../assets/theme/default/sass/colors';
@import '../../../assets/module/sass/course/toc.scss';
</style>



// WEBPACK FOOTER //
// src/app/course/components/TOC.vue